module.exports = __webpack_public_path__ + "img/huozai_1.cbf732cd.svg";